module.exports = __webpack_public_path__ + "static/img/logo-beg.ddd53a58.webp";